import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";

import { api } from "../../api/client";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { AuthLayout } from "../../components/layout/AuthLayout";
import { apiError } from "../../lib/apiError";
import { CURRENT_TERMS_VERSION } from "../../lib/terms";

export function GoogleConsentPage() {
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onContinue(event: FormEvent) {
    event.preventDefault();
    if (!acceptTerms) {
      setError("Zaakceptuj regulamin i politykę prywatności, aby kontynuować.");
      return;
    }
    setBusy(true);
    setError(null);
    const result = await api.POST("/api/auth/oauth-terms", { body: {} });
    setBusy(false);
    if (result.error) {
      setError(apiError(result.error, "Nie udało się przygotować logowania Google."));
      return;
    }
    window.location.href = "/auth/google";
  }

  return (
    <AuthLayout title="Kontynuuj z Google">
      <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      <p className="auth__intro">
        Zanim utworzysz konto przez Google, zaakceptuj regulamin i politykę prywatności.
      </p>
      <form className="auth__form" onSubmit={onContinue} data-testid="google-consent-form">
        <label className="auth__checkbox">
          <input
            type="checkbox"
            checked={acceptTerms}
            onChange={(event) => setAcceptTerms(event.target.checked)}
            data-testid="google-consent-terms"
          />
          <span>
            Akceptuję{" "}
            <Link to="/terms" target="_blank" rel="noopener noreferrer">
              regulamin
            </Link>{" "}
            (wersja {CURRENT_TERMS_VERSION}) oraz{" "}
            <Link to="/privacy" target="_blank" rel="noopener noreferrer">
              politykę prywatności
            </Link>
            .
          </span>
        </label>
        <button
          className="btn btn--google btn--block"
          type="submit"
          disabled={busy || !acceptTerms}
          data-testid="google-consent-submit"
        >
          Kontynuuj z Google
        </button>
      </form>
      <p className="auth__footer">
        <Link to="/register">Wróć do rejestracji</Link>
      </p>
    </AuthLayout>
  );
}
